import { WalletTransactionType, schemes, zSchema } from "@zeal/common";

export const getWalletTransactionRequestSchema = zSchema.object({
  wallet_transaction_id: schemes.uuid(),
});

export type TGetWalletTransactionRequestSchema = zSchema.infer<
  typeof getWalletTransactionRequestSchema
>;

export const getWalletTransactionResponseSchema = zSchema.object({
  date: zSchema.string(),
  gross_amount: zSchema.number(),
  last_four: zSchema.string(),
  net_amount: zSchema.number(),
  partner_fee: zSchema.number(),
  type: zSchema.nativeEnum(WalletTransactionType),
  walletTransactionID: schemes.uuid(),
  zeal_fee: zSchema.number(),
});

export type TGetWalletTransactionResponseSchema = zSchema.infer<
  typeof getWalletTransactionResponseSchema
>;
